<template>
    <section class="env-homesection" id="env-homesection">
        <div class="container">


            <h2 class="">Build your Digital City</h2>
            <div class="center-align">
                <div class="buttonall"
                     v-on:click="selectAllEnv('')"
                >Select All
                </div>
            </div>
            <div class="env-subtitle center-align horizontal-line">
                <h4>Environments</h4>
            </div>

            <div class="row category-list">
                <div class="verticalline"
                     v-for="line  in svglines"
                     v-bind:style="{left:line.from+'px'}"
                ></div>
                <div class="category-env col s12"
                     v-for="(type, index)  in envtype"
                     v-bind:class="[type.column2x ? 'xl5ths2X' : 'xl5ths']"
                >
                    <div class="col s12">
                        <div class="title">{{type.slug}}</div>
                        <div class="buttonall"
                             v-on:click="selectAllEnv(type.id)"
                        >Select All
                        </div>
                    </div>

                    <EnvBlockLand
                        v-for="env in environments"
                        v-if="type.id == env.type_id"
                        v-bind:type="type"
                        v-bind:env="env"
                        v-bind:selectEnvironments="selectEnvironments"
                        v-on:addEnv="addEnv"
                        v-on:setActiveEnv="setActiveEnv"
                    />

                </div>
            </div>

            <div class="row category-unite-svg">
                <SvgLine
                    v-for="svgl in svglines"
                    v-bind:svgl="svgl"
                />
            </div>

            <div class="row cat-but-wrap">
                <div class="category-unite-line"></div>
                <router-link :to="{ name: 'Digitalplace' }" class="button-create">
                    Create
                </router-link>
            </div>

        </div>
    </section>
</template>

<script>
    import EnvBlockLand from '@/components/landing/EnvBlockLand.vue'
    import SvgLine from '@/components/landing/SvgLine.vue'

    export default {
        name: 'EnvHEroSection',
        props: ['selectEnvironments'],
        data() {
            return {
                groupenvlist: '',
                environments: this.globalData.environments,
                envtype: this.globalData.environmenttype,
                selectEnv: {},
                svglines: [],
                center: 0,
                counter: 0,
            }
        },
        watch: {
            'selectEnvironments'() {

                // let groupstring = '';
                // this.environments.forEach((env, i) => {
                //     if (this.selectEnvironments.indexOf(env.id) != -1) {
                //         if (groupstring) {
                //             groupstring = groupstring + ', ' + env.id
                //         } else {
                //             groupstring = env.id
                //         }
                //     }
                // });
                // this.groupenvlist = groupstring
            }
        },
        mounted() {

            this.envtype.forEach((item, i) => {
                if (item.slug == 'retail') {
                    this.$set(this.envtype[i], 'column2x', true);
                } else {
                    this.$set(this.envtype[i], 'column2x', false);
                }
            });

            this.svgCalc();
            window.addEventListener('load', () => {
                this.svgCalc();
            })
        },
        components: {EnvBlockLand, SvgLine},
        methods: {
            setActiveEnv(env_id){
                this.$emit('setActiveEnv',env_id);
            },

            addEnv(el) {
                if (el.isActive) {
                    this.$emit('addEnv', el.id)
                } else {
                    this.$emit('removeEnv', el.id)
                }
            },
            selectAllEnv(type_id = '') {
                if (type_id) {
                    if (this.checkAllSelected(type_id)) {
                        this.environments.forEach((env, i) => {
                            if (type_id == env.type_id) {
                                this.$emit('removeEnv', env.id)
                            }
                        });
                    } else {
                        this.environments.forEach((env, i) => {
                            if (type_id == env.type_id) {
                                this.$emit('addEnv', env.id)
                            }
                        });
                    }

                } else {
                    if (this.checkAllSelected()) {
                        this.environments.forEach((env, i) => {
                            this.$emit('removeEnv', env.id)
                        });
                    } else {
                        this.environments.forEach((env, i) => {
                            this.$emit('addEnv', env.id)

                        });
                    }
                }
            },
            checkAllSelected(type_id) {
                let counter = 0;
                let counter_chek = 0;
                if (type_id){
                    this.environments.forEach((env, i) => {
                        if (type_id == env.type_id) {
                            if (this.selectEnvironments.indexOf(env.id) != -1) {
                                counter_chek++;
                            }
                            counter++;
                        }

                    });
                }else{
                    counter = this.environments.length;
                    counter_chek = this.selectEnvironments.length
                }

                if (counter == counter_chek) {
                    return true;

                } else {
                    return false;

                }
            },
            svgCalc() {
                // this.svglines
                var items = document.getElementsByClassName("category-env");
                var svgblock = document.getElementsByClassName("category-unite-svg")[0];
                this.center = Math.round(svgblock.offsetWidth / 2);
                var positions = []
                items.forEach((item, i) => {
                    if (i == 0) {
                        positions.push({
                            'id': 0,
                            'from': 0,
                            'to': this.center,
                        });
                    }
                    positions.push({
                        'id': i + 1,
                        'from': Math.round(item.offsetLeft + item.offsetWidth) - 2,
                        'to': this.center,
                    });
                });
                this.svglines = Object.assign({}, this.someObject, positions)

            },


        },
        updated(){
            this.svgCalc;
        },
        created() {
            window.addEventListener("resize", this.svgCalc);
        },
        destroyed() {
            window.removeEventListener("resize", this.svgCalc);
        },
        // computed:{
        // }
    }


</script>